<template>
    <ob1-popin-modal2
        :id="id"
        :aria-labelledby="id"
        :show-close-button="false"
        additional-classes="d-webview-none"
    >
        <div class="pt-1">
            <h3 class="my-1" v-html="title" />
            <div class="row">
                <div id="tdc-section" class="col-12 col-md-6">
                    <div>
                        <h4
                            class="lead fw-bold mb-0"
                            v-html="tdcSection.title"
                        />
                        <p
                            class="lead"
                            v-html="tdcSection.description1"
                        />
                        <ob1-message-complementaire
                            class="mb-1"
                            is-reduced
                            :has-alert-content="false"
                            :title="tdcSection.ecoText"
                            icon="icon-Eco-mode"
                        />
                    </div>
                    <ob1-boutons
                        id="online-button-id"
                        class="mt-1 mx-auto mx-md-0"
                        :is-button="tdcSection.button.button"
                        :label="tdcSection.button.label"
                        :is-secondary="true"
                        :data-oevent-category="tdcSection.button.tmsDTO.tagZone"
                        :data-oevent-action="tdcSection.button.tmsDTO.tagName"
                        :data-oevent-label="tdcHref"
                        :href="tdcHref"
                    />
                </div>
                <div class="col-12 d-md-none">
                    <hr class="separator separator--gray4 my-2">
                </div>
                <div id="eresa-section" class="col-12 col-md-6">
                    <div>
                        <h4
                            class="lead fw-bold mb-0"
                            v-html="eresaSection.title"
                        />
                        <p
                            class="lead"
                            v-html="eresaSection.description1"
                        />
                        <ob1-message-complementaire
                            class="mb-1"
                            is-reduced
                            :has-alert-content="false"
                            :title="eresaSection.ecoText"
                            icon="icon-Eco-mode"
                        />
                    </div>
                    <ob1-boutons
                        id="eresa-button-id"
                        class="mt-1 mx-auto mx-md-0"
                        :is-button="eresaSection.button.button"
                        :label="eresaSection.button.label"
                        :is-secondary="true"
                        :is-disabled="eresaSection.button.disabled"
                        :data-oevent-category="eresaSection.button.tmsDTO.tagZone"
                        :data-oevent-action="eresaSection.button.tmsDTO.tagName"
                        :data-oevent-label="eresaHref"
                        :href="eresaHref"
                    />
                </div>
                <div id="ecoFootNote" class="col-12 mt-2">
                    <p
                        class="mb-0 small"
                        v-html="ecoFootNote"
                    />
                </div>
            </div>
        </div>
    </ob1-popin-modal2>
</template>

<script>
import AdvantageBloc from "../fragments/AdvantageBloc.vue";

export default {
    name: "AllDisponibilitiesPopin",
    props: {
        // id de la popin
        id: {
            type: String,
            required: false,
            default: "allDisponibilitiesPopIn"
        },
        // titre de la popin
        title: {
            type: String,
            required: true
        },
        // section en ligne
        tdcSection: {
            type: Object,
            required: true
        },
        tdcHref: {
            type: String,
            required: true
        },
        // section eresa
        eresaSection: {
            type: Object,
            required: true
        },
        eresaHref: {
            type: String,
            required: true
        },
        // mentions écologiques dans le footer de la popin
        ecoFootNote: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
#eresa-button-id, #online-button-id {
    width: 100%
}
#tdc-section, #eresa-section {
    display: grid;
    align-content: space-between;
}
</style>
